import { OperatingHours } from './OperatingHours.main';

export { OperatingHours };
